module.exports = __webpack_public_path__ + "static/media/number6.25ce5aa4.svg";